import { render } from "./subpartA.vue?vue&type=template&id=0c7e2aa3"
import script from "./subpartA.vue?vue&type=script&lang=js"
export * from "./subpartA.vue?vue&type=script&lang=js"

import "./subpartA.vue?vue&type=style&index=0&id=0c7e2aa3&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__